import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClaimCmeCeComponent } from './components/claim-cme-ce.component';
import { SharedModule } from '../../shared/shared.module';
import { ClaimCmeCeConfirmationComponent } from './components/claim-cme-ce-confirmation/claim-cme-ce-confirmation.component';
import { ClaimCmeCeConfirmationMessageComponent } from './components/claim-cme-ce-confirmation-message/claim-cme-ce-confirmation-message.component';
import { ClaimCmeCeNotificationBoxComponent } from './components/claim-cme-ce-notification-box/claim-cme-ce-notification-box.component';
import { ClaimCmeCeHelpModalComponent } from './components/claim-cme-ce-help-modal/claim-cme-ce-help-modal.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CookieSessionInterceptor } from './cookie-session.interceptor';
// import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
// import { TooltipModule } from 'src/app/shared/components/tooltip/tooltip.module';
import { TooltipModule } from 'src/app/shared/components/tooltip/tooltip.module';

@NgModule({
    declarations: [
        ClaimCmeCeComponent,
        ClaimCmeCeConfirmationComponent,
        ClaimCmeCeConfirmationMessageComponent,
        ClaimCmeCeNotificationBoxComponent,
        ClaimCmeCeHelpModalComponent
    ],
    imports: [CommonModule, SharedModule, TooltipModule],
    exports: [ClaimCmeCeComponent],
    entryComponents: [],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CookieSessionInterceptor,
            multi: true,
        },
    ],
})
export class ClaimCmeCeModule {}
